'use client'

import * as React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'
import './slider.scss';

const sliderVariants = cva(
    'SliderRoot',
    {
      variants: {
        variant: {
          default: '',
          dark: 'Slider__dark',
          light: 'Slider__light',
        },
      },
      defaultVariants: {
        variant: 'default',
      },
    },
)

export interface SliderProps
  extends React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>,
    VariantProps<typeof sliderVariants> {}

export const Slider = React.forwardRef<
        React.ElementRef<typeof SliderPrimitive.Root>,
        SliderProps
    >(({ className, variant, ...props }, ref) => (
    <SliderPrimitive.Root 
        className={cn(sliderVariants({ variant, className }))}
        {...props}
        ref={ref}
    >
      <SliderPrimitive.Track className="SliderTrack">
        <SliderPrimitive.Range className="SliderRange" />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb className="SliderThumb" aria-label="Volume">
        <div className="SliderThumbInner" />
      </SliderPrimitive.Thumb>
      {props.defaultValue && props.defaultValue.length && 
        <SliderPrimitive.Thumb className="SliderThumb" aria-label="Volume">
            <div className="SliderThumbInner" />
        </SliderPrimitive.Thumb>
      }
    </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;
